

// // import React, { useEffect, useState } from 'react';
// // import { Modal, Button, Badge, Row, Col } from "react-bootstrap";
// // import axios from "axios";
// // import config from '../../Common/Configurations/APIConfig';
// // import DefaultData from '../../Common/CompanyData/DefaultData';

// // const emptyGuid = '00000000-0000-0000-0000-000000000000';
// // const THEME_COLOR = '#065f46';
// // const SECONDARY_COLOR = '#64748b';

// // // --- STYLES ---
// // const styles = {
// //     pageBackground: { backgroundColor: '#f1f5f9', minHeight: '100vh', paddingTop: '80px' },
// //     card: { border: 'none', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' },
// //     tableHeader: { backgroundColor: '#f8fafc', color: '#475569', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' },
// //     imgThumbnail: { width: '56px', height: '56px', objectFit: 'cover', borderRadius: '12px', border: '2px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
// //     actionBtn: { width: '36px', height: '36px', padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', transition: 'all 0.2s' },
// //     modalHeader: { borderBottom: '1px solid #f1f5f9', padding: '20px 24px' },
// //     label: { fontSize: '0.8rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '4px' }
// // };

// // // --- INITIAL VALUES ---
// // const initialProductValues = { prodcutId: emptyGuid, categoryId: '', brandId: '', productName: '', slug: '', description: '', quantityAvailable: 0, purchasePrice: 0, sellingPrice: 0, isActive: true };
// // const initialBrandValues = { brandId: emptyGuid, brandName: '' };
// // const initialImageValues = { productImageId: emptyGuid, productId: '', imageFile: null, imageSrc: '' };

// // const Product = () => {
// //     // --- STATE MANAGEMENT ---
// //     const [productList, setProductList] = useState([]);
// //     const [categories, setCategories] = useState([]); 
// //     const [brandsDropdown, setBrandsDropdown] = useState([]);
    
// //     const [showProductModal, setShowProductModal] = useState(false);
// //     const [productValues, setProductValues] = useState(initialProductValues);
// //     const [productErrors, setProductErrors] = useState({});
    
// //     const [showProductDeleteModal, setShowProductDeleteModal] = useState(false);
// //     const [productToDelete, setProductToDelete] = useState(null);
// //     const [productLoading, setProductLoading] = useState(false);

// //     const [brandList, setBrandList] = useState([]);
// //     const [showBrandListModal, setShowBrandListModal] = useState(false);
// //     const [showBrandFormModal, setShowBrandFormModal] = useState(false);
// //     const [brandValues, setBrandValues] = useState(initialBrandValues);
// //     const [brandErrors, setBrandErrors] = useState({});
// //     const [showBrandDeleteModal, setShowBrandDeleteModal] = useState(false);
// //     const [brandToDelete, setBrandToDelete] = useState(null);
// //     const [brandLoading, setBrandLoading] = useState(false);

// //     const [allImages, setAllImages] = useState([]); 
// //     const [showImageModal, setShowImageModal] = useState(false); 
// //     const [currentProductForImage, setCurrentProductForImage] = useState(null); 
// //     const [imageFormValues, setImageFormValues] = useState(initialImageValues); 
// //     const [imageErrors, setImageErrors] = useState({});
// //     const [imageLoading, setImageLoading] = useState(false);
// //     const [showImageDeleteModal, setShowImageDeleteModal] = useState(false);
// //     const [imageToDelete, setImageToDelete] = useState(null);

// //     const [showViewModal, setShowViewModal] = useState(false);
// //     const [viewProductItem, setViewProductItem] = useState(null);
    
// //     // Get currency from DefaultData
// //     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

// //     // --- DATA LOADING ---
// //     const LoadData = async () => {
// //         try {
// //             const [prodRes, catRes, brandRes, imgRes] = await Promise.all([
// //                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
// //                 axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES),
// //                 axios.get(config.APIACTIVEURL + config.GETALLBRANDS),
// //                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
// //             ]);
// //             setProductList(prodRes.data || []);
// //             setCategories(catRes.data || []);
// //             setBrandsDropdown(brandRes.data || []);
// //             setAllImages(imgRes.data || []);
// //         } catch (error) { console.error("Error loading data", error); }
// //     };

// //     const RefreshProducts = async () => { setProductList((await axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS)).data || []); };
// //     const RefreshBrands = async () => { 
// //         const res = await axios.get(config.APIACTIVEURL + config.GETALLBRANDS);
// //         setBrandList(res.data || []); setBrandsDropdown(res.data || []); 
// //     };
// //     const RefreshImages = async () => { setAllImages((await axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)).data || []); };

// //     useEffect(() => { LoadData(); }, []);

// //     // --- HELPERS ---
// //     const getMainImage = (prodId) => { 
// //         // Handle both variations of ID typo
// //         const img = allImages.find(x => x.productId === prodId); 
// //         return img ? img.imageSrc : null; 
// //     };
// //     const getCategoryName = (id) => { const cat = categories.find(c => c.categoryId === id); return cat ? cat.name : 'Uncategorized'; };
// //     const getBrandName = (id) => { const br = brandsDropdown.find(b => b.brandId === id); return br ? br.brandName : 'No Brand'; };
    
// //     const formatCurrency = (amount) => {
// //         return `${currency} ${amount?.toFixed(2) || '0.00'}`;
// //     };

// //     // --- HANDLERS (CRUD) ---
// //     const handleProductInput = (e) => { const { name, value, type, checked } = e.target; setProductValues({ ...productValues, [name]: type === 'checkbox' ? checked : value }); };
// //     const handleProductSubmit = async (e) => {
// //         e.preventDefault();
// //         let temp = {};
// //         if(!productValues.productName) temp.productName = "Required";
// //         if(!productValues.categoryId) temp.categoryId = "Required";
// //         if(!productValues.brandId) temp.brandId = "Required";
// //         setProductErrors(temp);
// //         if(Object.values(temp).some(x => x)) return;

// //         setProductLoading(true);
// //         try {
// //             const isNew = productValues.prodcutId === emptyGuid;
// //             await axios({
// //                 method: isNew ? 'POST' : 'PUT',
// //                 url: config.APIACTIVEURL + (isNew ? config.CREATEPRODUCT : config.UPDATEPRODUCT),
// //                 data: productValues
// //             });
// //             setShowProductModal(false); setProductValues(initialProductValues); RefreshProducts();
// //         } catch (error) { console.error(error); } finally { setProductLoading(false); }
// //     };
// //     const handleProductDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEPRODUCT}/${productToDelete}`); setShowProductDeleteModal(false); RefreshProducts(); };

// //     const handleBrandSubmit = async (e) => {
// //         e.preventDefault();
// //         if (!brandValues.brandName) { setBrandErrors({ brandName: "Required" }); return; }
// //         setBrandLoading(true);
// //         try {
// //             const isNew = brandValues.brandId === emptyGuid;
// //             await axios({ method: isNew ? 'POST' : 'PUT', url: config.APIACTIVEURL + (isNew ? config.CREATEBRAND : config.UPDATEBRAND), data: brandValues });
// //             setShowBrandFormModal(false); RefreshBrands();
// //         } catch(e){console.error(e)} finally{setBrandLoading(false)}
// //     };
// //     const handleBrandDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEBRAND}/${brandToDelete}`); setShowBrandDeleteModal(false); RefreshBrands(); };
// //     const handleViewBrands = () => { setShowBrandListModal(true); RefreshBrands(); };
// //     const openBrandForm = (item = null) => { setBrandValues(item || initialBrandValues); setBrandErrors({}); setShowBrandFormModal(true); };

// //     // UPDATED GALLERY LOGIC
// //     const handleManageImages = (product) => { 
// //         const actualId = product.prodcutId || product.productId;
// //         setCurrentProductForImage(product); 
// //         setImageFormValues({ ...initialImageValues, productId: actualId }); 
// //         setImageErrors({});
// //         setShowImageModal(true); 
// //     };

// //     const handleImageFileChange = (e) => {
// //         if (e.target.files[0]) {
// //             const file = e.target.files[0];
// //             const reader = new FileReader();
// //             reader.onload = (x) => setImageFormValues({ ...imageFormValues, imageFile: file, imageSrc: x.target.result });
// //             reader.readAsDataURL(file);
// //         }
// //     };

// //     // UPDATED IMAGE UPLOAD (Latest working feature)
// //     const handleImageUpload = async (e) => {
// //         e.preventDefault();
// //         if (!imageFormValues.imageFile) { setImageErrors({ imageFile: "Select an image" }); return; }
// //         setImageLoading(true);

// //         const actualId = currentProductForImage.prodcutId || currentProductForImage.productId;
// //         const formData = new FormData();
// //         // Matching ProductImageRequest properties exactly
// //         formData.append('ProductImageId', emptyGuid); 
// //         formData.append('ProductId', actualId); 
// //         formData.append('ImageFile', imageFormValues.imageFile);

// //         try { 
// //             await axios.post(config.APIACTIVEURL + config.CREATEPRODUCTIMAGE, formData); 
// //             setImageFormValues({ ...initialImageValues, productId: actualId }); 
// //             RefreshImages(); 
// //         }
// //         catch(e){ console.error("Upload failed", e.response?.data || e.message); } 
// //         finally{ setImageLoading(false); }
// //     };

// //     const handleImageDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEPRODUCTIMAGE}/${imageToDelete}`); setShowImageDeleteModal(false); RefreshImages(); };

// //     const handleViewDetails = (item) => { setViewProductItem(item); setShowViewModal(true); };

// //     return (
// //         <div style={styles.pageBackground}>
// //             <div className="container-fluid px-4 pb-5">
                
// //                 <div className="d-flex justify-content-between align-items-center mb-4">
// //                     <div>
// //                         <h3 className="fw-bold mb-1" style={{ color: '#1e293b' }}>Products</h3>
// //                         <p className="text-muted mb-0">Manage catalog, brands, and galleries.</p>
// //                     </div>
// //                     <button className="btn text-white fw-bold px-4 shadow-sm"
// //                         style={{ backgroundColor: THEME_COLOR }}
// //                         onClick={() => { setProductValues(initialProductValues); setShowProductModal(true); }}>
// //                         <i className="ri-add-line me-1"></i> Add Product
// //                     </button>
// //                 </div>

// //                 <div className="card" style={styles.card}>
// //                     <div className="card-body p-0">
// //                         <div className="table-responsive rounded-4">
// //                             <table className="table table-hover align-middle mb-0">
// //                                 <thead style={styles.tableHeader}>
// //                                     <tr>
// //                                         <th className="ps-4 py-3">Product</th>
// //                                         <th className="py-3">Category</th>
// //                                         <th className="py-3">Brand</th>
// //                                         <th className="py-3">Stock</th>
// //                                         <th className="py-3">Price</th>
// //                                         <th className="py-3">Status</th>
// //                                         <th className="py-3 text-center">Actions</th>
// //                                     </tr>
// //                                 </thead>
// //                                 <tbody>
// //                                     {productList.map((item) => {
// //                                         const actualId = item.prodcutId || item.productId;
// //                                         const thumbSrc = getMainImage(actualId);
// //                                         return (
// //                                             <tr key={actualId} style={{ cursor: 'pointer' }}>
// //                                                 <td className="ps-4 py-3">
// //                                                     <div className="d-flex align-items-center gap-3">
// //                                                         <div className="position-relative">
// //                                                             {thumbSrc ? (
// //                                                                 <img src={thumbSrc} alt="" style={styles.imgThumbnail} />
// //                                                             ) : (
// //                                                                 <div className="d-flex align-items-center justify-content-center bg-light rounded-3" style={{ width: '56px', height: '56px' }}>
// //                                                                     <i className="ri-image-line text-muted fs-4"></i>
// //                                                                 </div>
// //                                                             )}
// //                                                         </div>
// //                                                         <div>
// //                                                             <div className="fw-bold text-dark">{item.productName}</div>
// //                                                             <small className="text-muted d-block">{item.slug}</small>
// //                                                         </div>
// //                                                     </div>
// //                                                 </td>
// //                                                 <td><span className="badge bg-light text-secondary border fw-normal px-2 py-1">{getCategoryName(item.categoryId)}</span></td>
// //                                                 <td><span className="fw-bold" style={{ color: SECONDARY_COLOR }}>{getBrandName(item.brandId)}</span></td>
// //                                                 <td><span className={`fw-bold ${item.quantityAvailable < 10 ? 'text-danger' : 'text-dark'}`}>{item.quantityAvailable} units</span></td>
// //                                                 <td className="fw-bold text-dark">{formatCurrency(item.sellingPrice)}</td>
// //                                                 <td><span className={`badge rounded-pill px-3 py-2 ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>{item.isActive ? 'Active' : 'Inactive'}</span></td>
// //                                                 <td className="text-center">
// //                                                     <div className="d-flex justify-content-center gap-1">
// //                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => handleViewDetails(item)} title="View Details"><i className="ri-eye-line"></i></button>
// //                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => handleManageImages(item)} title="Gallery"><i className="ri-image-add-line text-warning"></i></button>
// //                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={handleViewBrands} title="Brands"><i className="ri-price-tag-3-line text-info"></i></button>
// //                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => { setProductValues(item); setShowProductModal(true); }}><i className="ri-pencil-line text-primary"></i></button>
// //                                                         <button className="btn btn-light border-0" style={{...styles.actionBtn, backgroundColor: '#fef2f2'}} onClick={() => { setProductToDelete(actualId); setShowProductDeleteModal(true); }}><i className="ri-delete-bin-line text-danger"></i></button>
// //                                                     </div>
// //                                                 </td>
// //                                             </tr>
// //                                         );
// //                                     })}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 {/* --- MODALS (DETAILS REMAIN UNTOUCHED AS REQUESTED) --- */}
// //                 <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg" centered>
// //                     <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold"><i className="ri-price-tag-3-fill me-2" style={{color: THEME_COLOR}}></i>Product Overview</Modal.Title></Modal.Header>
// //                     <Modal.Body className="p-0">
// //                         {viewProductItem && (
// //                             <div className="container-fluid p-0">
// //                                 <div className="p-4 bg-light border-bottom">
// //                                     <div className="d-flex justify-content-between align-items-start">
// //                                         <div>
// //                                             <h4 className="fw-bold text-dark mb-1">{viewProductItem.productName}</h4>
// //                                             <div className="d-flex align-items-center gap-2">
// //                                                 <span className="badge bg-white border text-secondary">{getCategoryName(viewProductItem.categoryId)}</span>
// //                                                 <span className="text-secondary small fw-bold">{getBrandName(viewProductItem.brandId)}</span>
// //                                             </div>
// //                                         </div>
// //                                         <div className="text-end">
// //                                             <h3 className="fw-bold mb-0" style={{color: THEME_COLOR}}>{formatCurrency(viewProductItem.sellingPrice)}</h3>
// //                                             <Badge bg={viewProductItem.quantityAvailable > 0 ? 'success' : 'danger'}>{viewProductItem.quantityAvailable > 0 ? 'In Stock' : 'Out of Stock'}</Badge>
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                                 <div className="row g-0">
// //                                     <div className="col-md-7 p-4 border-end">
// //                                         <div className="mb-4">
// //                                             <div style={styles.label}>Description</div>
// //                                             <p className="text-secondary small">{viewProductItem.description || "No description provided."}</p>
// //                                         </div>
// //                                     </div>
// //                                     <div className="col-md-5 p-4 bg-light">
// //                                         <div style={styles.label} className="mb-3">Image Gallery</div>
// //                                         <div className="row g-2">
// //                                             {allImages.filter(img => img.productId === (viewProductItem.prodcutId || viewProductItem.productId)).map((img, idx) => (
// //                                                 <div className="col-6" key={idx}>
// //                                                     <img src={img.imageSrc} alt="" className="w-100 rounded shadow-sm" style={{height: '100px', objectFit: 'cover'}} />
// //                                                 </div>
// //                                             ))}
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         )}
// //                     </Modal.Body>
// //                 </Modal>

// //                 <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered backdrop="static">
// //                     <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold">{productValues.prodcutId === emptyGuid ? "New Product" : "Edit Product"}</Modal.Title></Modal.Header>
// //                     <Modal.Body className="p-4">
// //                         <form onSubmit={handleProductSubmit}>
// //                             <Row className="g-3">
// //                                 <Col md={6}><div className="form-floating"><input type="text" className={`form-control ${productErrors.productName ? 'is-invalid' : ''}`} id="pName" placeholder="Name" name="productName" value={productValues.productName} onChange={handleProductInput} /><label htmlFor="pName">Product Name</label></div></Col>
// //                                 <Col md={6}><div className="form-floating"><input type="text" className="form-control" id="pSlug" placeholder="Slug" name="slug" value={productValues.slug} onChange={handleProductInput} /><label htmlFor="pSlug">Slug (Optional)</label></div></Col>
// //                                 <Col md={6}><div className="form-floating"><select className={`form-select ${productErrors.categoryId ? 'is-invalid' : ''}`} id="pCat" name="categoryId" value={productValues.categoryId} onChange={handleProductInput}><option value="">Select Category</option>{categories.map(c => <option key={c.categoryId} value={c.categoryId}>{c.name}</option>)}</select><label htmlFor="pCat">Category</label></div></Col>
// //                                 <Col md={6}><div className="form-floating"><select className={`form-select ${productErrors.brandId ? 'is-invalid' : ''}`} id="pBrand" name="brandId" value={productValues.brandId} onChange={handleProductInput}><option value="">Select Brand</option>{brandsDropdown.map(b => <option key={b.brandId} value={b.brandId}>{b.brandName}</option>)}</select><label htmlFor="pBrand">Brand</label></div></Col>
// //                                 <Col md={12}><div className="form-floating"><textarea className="form-control" placeholder="Desc" id="pDesc" style={{height: '100px'}} name="description" value={productValues.description} onChange={handleProductInput}></textarea><label htmlFor="pDesc">Description</label></div></Col>
// //                                 <Col md={4}><div className="form-floating"><input type="number" className="form-control" id="pQty" placeholder="0" name="quantityAvailable" value={productValues.quantityAvailable} onChange={handleProductInput} /><label htmlFor="pQty">Quantity</label></div></Col>
// //                                 <Col md={4}><div className="form-floating"><input type="number" className="form-control" id="pBuy" placeholder="0" name="purchasePrice" value={productValues.purchasePrice} onChange={handleProductInput} /><label htmlFor="pBuy">Price ({currency})</label></div></Col>
// //                                 <Col md={4}><div className="form-floating"><input type="number" className="form-control" id="pSell" placeholder="0" name="sellingPrice" value={productValues.sellingPrice} onChange={handleProductInput} /><label htmlFor="pSell">Selling Price ({currency})</label></div></Col>
// //                                 <Col md={12}><div className="form-check form-switch p-3 bg-light rounded-3 d-flex align-items-center gap-3"><input className="form-check-input m-0" type="checkbox" role="switch" id="pActive" name="isActive" checked={productValues.isActive} onChange={handleProductInput} style={{width: '3em', height: '1.5em'}} /><label className="form-check-label fw-bold text-dark" htmlFor="pActive">Product is Active</label></div></Col>
// //                             </Row>
// //                             <div className="d-flex justify-content-end gap-2 mt-4">
// //                                 <Button variant="light" className="px-4 rounded-pill" onClick={() => setShowProductModal(false)}>Cancel</Button>
// //                                 <Button type="submit" className="px-5 rounded-pill text-white fw-bold shadow-sm" disabled={productLoading} style={{backgroundColor: THEME_COLOR, border: 'none'}}>{productLoading ? 'Saving...' : 'Save Product'}</Button>
// //                             </div>
// //                         </form>
// //                     </Modal.Body>
// //                 </Modal>

// //                 <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
// //                     <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold h5">Gallery Manager</Modal.Title></Modal.Header>
// //                     <Modal.Body className="p-4">
// //                         <div className="p-4 bg-light rounded-4 mb-4 border border-dashed text-center">
// //                             <h6 className="fw-bold text-dark mb-3">Upload New Image</h6>
// //                             <form onSubmit={handleImageUpload} className="d-flex flex-column align-items-center gap-3">
// //                                 {imageFormValues.imageSrc ? (
// //                                     <img src={imageFormValues.imageSrc} alt="" className="shadow-sm rounded-3" style={{width: '100px', height: '100px', objectFit: 'cover'}} />
// //                                 ) : (
// //                                     <div className="bg-white rounded-3 shadow-sm d-flex align-items-center justify-content-center" style={{width: '100px', height: '100px'}}><i className="ri-image-add-line fs-2 text-muted"></i></div>
// //                                 )}
// //                                 <div className="d-flex gap-2 w-100 justify-content-center">
// //                                     <input type="file" accept="image/*" onChange={handleImageFileChange} className="form-control w-50" />
// //                                     <Button type="submit" disabled={imageLoading} className="text-white px-4 fw-bold" style={{backgroundColor: THEME_COLOR}}>Upload</Button>
// //                                 </div>
// //                                 {imageErrors.imageFile && <small className="text-danger">{imageErrors.imageFile}</small>}
// //                             </form>
// //                         </div>
// //                         <div className="row g-3">
// //                             {allImages.filter(img => img.productId === (currentProductForImage?.prodcutId || currentProductForImage?.productId)).map((img, idx) => (
// //                                 <div className="col-6 col-md-3" key={idx}>
// //                                     <div className="card border-0 shadow-sm overflow-hidden position-relative group-action">
// //                                         <img src={img.imageSrc} alt="" className="w-100" style={{height: '120px', objectFit: 'cover'}} />
// //                                         <button className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2 shadow" onClick={() => { setImageToDelete(img.productImageId); setShowImageDeleteModal(true); }}><i className="ri-delete-bin-line"></i></button>
// //                                     </div>
// //                                 </div>
// //                             ))}
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {/* --- SIMPLE UTILITY MODALS (BRAND/DELETE) --- */}
// //                 <Modal show={showBrandListModal} onHide={() => setShowBrandListModal(false)} centered scrollable>
// //                     <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold h5">Brand Management</Modal.Title></Modal.Header>
// //                     <Modal.Body className="p-0">
// //                         <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
// //                             <span className="text-muted small fw-bold text-uppercase">Brands List</span>
// //                             <Button size="sm" className="text-white rounded-pill fw-bold" style={{backgroundColor: THEME_COLOR}} onClick={() => openBrandForm()}>+ Add Brand</Button>
// //                         </div>
// //                         <div className="table-responsive">
// //                             <table className="table table-hover align-middle mb-0">
// //                                 <tbody>
// //                                     {brandList.map(item => (
// //                                         <tr key={item.brandId}>
// //                                             <td className="ps-4 fw-bold text-dark">{item.brandName}</td>
// //                                             <td className="text-end pe-4">
// //                                                 <button className="btn btn-link p-0 text-primary me-3" onClick={() => openBrandForm(item)}>Edit</button>
// //                                                 <button className="btn btn-link p-0 text-danger" onClick={() => { setBrandToDelete(item.brandId); setShowBrandDeleteModal(true); }}>Delete</button>
// //                                             </td>
// //                                         </tr>
// //                                     ))}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //                 <Modal show={showBrandFormModal} onHide={() => setShowBrandFormModal(false)} centered>
// //                     <Modal.Body className="p-4">
// //                         <h5 className="fw-bold mb-3">{brandValues.brandId === emptyGuid ? 'Add Brand' : 'Edit Brand'}</h5>
// //                         <form onSubmit={handleBrandSubmit}>
// //                             <input className="form-control mb-3" placeholder="Brand Name" value={brandValues.brandName} onChange={(e) => setBrandValues({ ...brandValues, brandName: e.target.value })} />
// //                             <Button type="submit" className="w-100 text-white fw-bold" style={{backgroundColor: THEME_COLOR}}>Save</Button>
// //                         </form>
// //                     </Modal.Body>
// //                 </Modal>

// //                 <Modal show={showProductDeleteModal} onHide={() => setShowProductDeleteModal(false)} centered size="sm">
// //                     <Modal.Body className="text-center py-4">
// //                         <div className="display-4 text-danger mb-3"><i className="ri-alert-line"></i></div>
// //                         <h5 className="fw-bold">Delete Product?</h5>
// //                         <p className="text-muted small">This action cannot be undone.</p>
// //                         <div className="d-flex justify-content-center gap-2">
// //                             <Button variant="light" onClick={() => setShowProductDeleteModal(false)}>Cancel</Button>
// //                             <Button variant="danger" onClick={handleProductDelete}>Delete</Button>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {[
// //                     { show: showBrandDeleteModal, hide: () => setShowBrandDeleteModal(false), action: handleBrandDelete, title: "Delete Brand?" },
// //                     { show: showImageDeleteModal, hide: () => setShowImageDeleteModal(false), action: handleImageDelete, title: "Delete Image?" }
// //                 ].map((m, i) => (
// //                     <Modal key={i} show={m.show} onHide={m.hide} centered size="sm">
// //                         <Modal.Body className="text-center py-4">
// //                             <h5 className="fw-bold">{m.title}</h5>
// //                             <div className="d-flex justify-content-center gap-2 mt-3">
// //                                 <Button variant="light" onClick={m.hide}>Cancel</Button>
// //                                 <Button variant="danger" onClick={m.action}>Delete</Button>
// //                             </div>
// //                         </Modal.Body>
// //                     </Modal>
// //                 ))}
// //             </div>
// //         </div>
// //     );
// // };

// // export default Product;
// //web view 



// import React, { useEffect, useState } from 'react';
// import { Modal, Button, Badge, Row, Col } from "react-bootstrap";
// import { useNavigate } from 'react-router-dom'; // Added for Mobile UX
// import axios from "axios";
// import config from '../../Common/Configurations/APIConfig';
// import DefaultData from '../../Common/CompanyData/DefaultData';

// const emptyGuid = '00000000-0000-0000-0000-000000000000';
// const THEME_COLOR = '#065f46';
// const SECONDARY_COLOR = '#64748b';

// // --- STYLES ---
// const styles = {
//     pageBackground: { backgroundColor: '#f1f5f9', minHeight: '100vh', paddingTop: '80px' },
//     card: { border: 'none', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' },
//     tableHeader: { backgroundColor: '#f8fafc', color: '#475569', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' },
//     imgThumbnail: { width: '56px', height: '56px', objectFit: 'cover', borderRadius: '12px', border: '2px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
//     actionBtn: { width: '36px', height: '36px', padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', transition: 'all 0.2s' },
//     modalHeader: { borderBottom: '1px solid #f1f5f9', padding: '20px 24px' },
//     label: { fontSize: '0.8rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '4px' }
// };

// const initialProductValues = { prodcutId: emptyGuid, categoryId: '', brandId: '', productName: '', slug: '', description: '', quantityAvailable: 0, purchasePrice: 0, sellingPrice: 0, isActive: true };
// const initialBrandValues = { brandId: emptyGuid, brandName: '' };
// const initialImageValues = { productImageId: emptyGuid, productId: '', imageFile: null, imageSrc: '' };

// const Product = () => {
//     const navigate = useNavigate(); // Added
//     const [productList, setProductList] = useState([]);
//     const [categories, setCategories] = useState([]); 
//     const [brandsDropdown, setBrandsDropdown] = useState([]);
    
//     const [showProductModal, setShowProductModal] = useState(false);
//     const [productValues, setProductValues] = useState(initialProductValues);
//     const [productErrors, setProductErrors] = useState({});
    
//     const [showProductDeleteModal, setShowProductDeleteModal] = useState(false);
//     const [productToDelete, setProductToDelete] = useState(null);
//     const [productLoading, setProductLoading] = useState(false);

//     const [brandList, setBrandList] = useState([]);
//     const [showBrandListModal, setShowBrandListModal] = useState(false);
//     const [showBrandFormModal, setShowBrandFormModal] = useState(false);
//     const [brandValues, setBrandValues] = useState(initialBrandValues);
//     const [brandErrors, setBrandErrors] = useState({});
//     const [showBrandDeleteModal, setShowBrandDeleteModal] = useState(false);
//     const [brandToDelete, setBrandToDelete] = useState(null);
//     const [brandLoading, setBrandLoading] = useState(false);

//     const [allImages, setAllImages] = useState([]); 
//     const [showImageModal, setShowImageModal] = useState(false); 
//     const [currentProductForImage, setCurrentProductForImage] = useState(null); 
//     const [imageFormValues, setImageFormValues] = useState(initialImageValues); 
//     const [imageErrors, setImageErrors] = useState({});
//     const [imageLoading, setImageLoading] = useState(false);
//     const [showImageDeleteModal, setShowImageDeleteModal] = useState(false);
//     const [imageToDelete, setImageToDelete] = useState(null);

//     const [showViewModal, setShowViewModal] = useState(false);
//     const [viewProductItem, setViewProductItem] = useState(null);
    
//     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

//     const LoadData = async () => {
//         try {
//             const [prodRes, catRes, brandRes, imgRes] = await Promise.all([
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
//                 axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES),
//                 axios.get(config.APIACTIVEURL + config.GETALLBRANDS),
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
//             ]);
//             setProductList(prodRes.data || []);
//             setCategories(catRes.data || []);
//             setBrandsDropdown(brandRes.data || []);
//             setAllImages(imgRes.data || []);
//         } catch (error) { console.error("Error loading data", error); }
//     };

//     const RefreshProducts = async () => { setProductList((await axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS)).data || []); };
//     const RefreshBrands = async () => { 
//         const res = await axios.get(config.APIACTIVEURL + config.GETALLBRANDS);
//         setBrandList(res.data || []); setBrandsDropdown(res.data || []); 
//     };
//     const RefreshImages = async () => { setAllImages((await axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)).data || []); };

//     useEffect(() => { LoadData(); }, []);

//     const getMainImage = (prodId) => { 
//         const img = allImages.find(x => x.productId === prodId); 
//         return img ? img.imageSrc : null; 
//     };
//     const getCategoryName = (id) => { const cat = categories.find(c => c.categoryId === id); return cat ? cat.name : 'Uncategorized'; };
//     const getBrandName = (id) => { const br = brandsDropdown.find(b => b.brandId === id); return br ? br.brandName : 'No Brand'; };
    
//     const formatCurrency = (amount) => {
//         return `${currency} ${amount?.toFixed(2) || '0.00'}`;
//     };

//     const handleProductInput = (e) => { const { name, value, type, checked } = e.target; setProductValues({ ...productValues, [name]: type === 'checkbox' ? checked : value }); };
    
//     const handleProductSubmit = async (e) => {
//         e.preventDefault();
//         let temp = {};
//         if(!productValues.productName) temp.productName = "Required";
//         if(!productValues.categoryId) temp.categoryId = "Required";
//         if(!productValues.brandId) temp.brandId = "Required";
//         setProductErrors(temp);
//         if(Object.values(temp).some(x => x)) return;

//         setProductLoading(true);
//         try {
//             const isNew = productValues.prodcutId === emptyGuid;
//             await axios({
//                 method: isNew ? 'POST' : 'PUT',
//                 url: config.APIACTIVEURL + (isNew ? config.CREATEPRODUCT : config.UPDATEPRODUCT),
//                 data: productValues
//             });
//             setShowProductModal(false); setProductValues(initialProductValues); RefreshProducts();
//         } catch (error) { console.error(error); } finally { setProductLoading(false); }
//     };

//     const handleProductDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEPRODUCT}/${productToDelete}`); setShowProductDeleteModal(false); RefreshProducts(); };

//     const handleBrandSubmit = async (e) => {
//         e.preventDefault();
//         if (!brandValues.brandName) { setBrandErrors({ brandName: "Required" }); return; }
//         setBrandLoading(true);
//         try {
//             const isNew = brandValues.brandId === emptyGuid;
//             await axios({ method: isNew ? 'POST' : 'PUT', url: config.APIACTIVEURL + (isNew ? config.CREATEBRAND : config.UPDATEBRAND), data: brandValues });
//             setShowBrandFormModal(false); RefreshBrands();
//         } catch(e){console.error(e)} finally{setBrandLoading(false)}
//     };

//     const handleBrandDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEBRAND}/${brandToDelete}`); setShowBrandDeleteModal(false); RefreshBrands(); };
//     const handleViewBrands = () => { setShowBrandListModal(true); RefreshBrands(); };
//     const openBrandForm = (item = null) => { setBrandValues(item || initialBrandValues); setBrandErrors({}); setShowBrandFormModal(true); };

//     const handleManageImages = (product) => { 
//         const actualId = product.prodcutId || product.productId;
//         setCurrentProductForImage(product); 
//         setImageFormValues({ ...initialImageValues, productId: actualId }); 
//         setImageErrors({});
//         setShowImageModal(true); 
//     };

//     const handleImageFileChange = (e) => {
//         if (e.target.files[0]) {
//             const file = e.target.files[0];
//             const reader = new FileReader();
//             reader.onload = (x) => setImageFormValues({ ...imageFormValues, imageFile: file, imageSrc: x.target.result });
//             reader.readAsDataURL(file);
//         }
//     };

//     const handleImageUpload = async (e) => {
//         e.preventDefault();
//         if (!imageFormValues.imageFile) { setImageErrors({ imageFile: "Select an image" }); return; }
//         setImageLoading(true);

//         const actualId = currentProductForImage.prodcutId || currentProductForImage.productId;
//         const formData = new FormData();
//         formData.append('ProductImageId', emptyGuid); 
//         formData.append('ProductId', actualId); 
//         formData.append('ImageFile', imageFormValues.imageFile);

//         try { 
//             await axios.post(config.APIACTIVEURL + config.CREATEPRODUCTIMAGE, formData); 
//             setImageFormValues({ ...initialImageValues, productId: actualId }); 
//             RefreshImages(); 
//         }
//         catch(e){ console.error("Upload failed", e.response?.data || e.message); } 
//         finally{ setImageLoading(false); }
//     };

//     const handleImageDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEPRODUCTIMAGE}/${imageToDelete}`); setShowImageDeleteModal(false); RefreshImages(); };

//     const handleViewDetails = (item) => { setViewProductItem(item); setShowViewModal(true); };

//     return (
//         <div style={styles.pageBackground}>
//             <div className="container-fluid px-3 px-lg-4 pb-5">
                
//                 {/* Mobile Header with Back Button */}
//                 <div className="d-flex align-items-center mb-3 d-lg-none">
//                     <button className="btn btn-sm btn-light border shadow-sm rounded-pill me-2" onClick={() => navigate(-1)}>
//                         <i className="ri-arrow-left-line"></i> Back
//                     </button>
//                     <h5 className="fw-bold mb-0">Products</h5>
//                 </div>

//                 <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
//     <div>
//         <h3 className="fw-bold mb-1" style={{ color: '#1e293b' }}>Products</h3>
//         <p className="text-muted mb-0 small">Manage catalog, brands, and galleries.</p>
//     </div>
//     {/* REMOVED w-100 from desktop, added d-block to force sizing */}
//     <div className="text-start">
//         <button className="btn text-white fw-bold px-4 shadow-sm w-sm-100"
//             style={{ backgroundColor: THEME_COLOR, width: 'fit-content' }}
//             onClick={() => { setProductValues(initialProductValues); setShowProductModal(true); }}>
//             <i className="ri-add-line me-1"></i> Add Product
//         </button>
//     </div>
// </div>

//                 <div className="card" style={styles.card}>
//                     <div className="card-body p-0">
//                         <div className="table-responsive rounded-4">
//                             <table className="table table-hover align-middle mb-0" style={{ minWidth: '950px' }}>
//                                 <thead style={styles.tableHeader}>
//                                     <tr>
//                                         <th className="ps-4 py-3">Product</th>
//                                         <th className="py-3">Category</th>
//                                         <th className="py-3">Brand</th>
//                                         <th className="py-3">Stock</th>
//                                         <th className="py-3">Price</th>
//                                         <th className="py-3">Status</th>
//                                         <th className="py-3 text-center">Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {productList.map((item) => {
//                                         const actualId = item.prodcutId || item.productId;
//                                         const thumbSrc = getMainImage(actualId);
//                                         return (
//                                             <tr key={actualId}>
//                                                 <td className="ps-4 py-3">
//                                                     <div className="d-flex align-items-center gap-2">
//                                                         {thumbSrc ? (
//                                                             <img src={thumbSrc} alt="" style={styles.imgThumbnail} />
//                                                         ) : (
//                                                             <div className="d-flex align-items-center justify-content-center bg-light rounded-3" style={{ width: '45px', height: '45px' }}>
//                                                                 <i className="ri-image-line text-muted"></i>
//                                                             </div>
//                                                         )}
//                                                         <div>
//                                                             <div className="fw-bold text-dark small">{item.productName}</div>
//                                                             <small className="text-muted extra-small d-block">{item.slug}</small>
//                                                         </div>
//                                                     </div>
//                                                 </td>
//                                                 <td><Badge bg="light" text="secondary" className="border font-normal">{getCategoryName(item.categoryId)}</Badge></td>
//                                                 <td className="small fw-bold">{getBrandName(item.brandId)}</td>
//                                                 <td className="small">{item.quantityAvailable} units</td>
//                                                 <td className="fw-bold text-dark small">{formatCurrency(item.sellingPrice)}</td>
//                                                 <td><Badge pill bg={item.isActive ? 'success-subtle' : 'danger-subtle'} className={item.isActive ? 'text-success' : 'text-danger'}>{item.isActive ? 'Active' : 'Inactive'}</Badge></td>
//                                                 <td className="text-center">
//                                                     <div className="d-flex justify-content-center gap-1">
//                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => handleViewDetails(item)} title="View"><i className="ri-eye-line"></i></button>
//                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => handleManageImages(item)} title="Gallery"><i className="ri-image-add-line text-warning"></i></button>
//                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={handleViewBrands} title="Brands"><i className="ri-price-tag-3-line text-info"></i></button>
//                                                         <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => { setProductValues(item); setShowProductModal(true); }}><i className="ri-pencil-line text-primary"></i></button>
//                                                         <button className="btn btn-light border-0" style={{...styles.actionBtn, backgroundColor: '#fef2f2'}} onClick={() => { setProductToDelete(actualId); setShowProductDeleteModal(true); }}><i className="ri-delete-bin-line text-danger"></i></button>
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         );
//                                     })}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>

//                 {/* MODALS: All Logic Preserved */}
//                 <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg" centered>
//                     <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold h6"><i className="ri-price-tag-3-fill me-2" style={{color: THEME_COLOR}}></i>Product Overview</Modal.Title></Modal.Header>
//                     <Modal.Body className="p-0">
//                         {viewProductItem && (
//                             <div className="container-fluid p-0">
//                                 <div className="p-3 p-md-4 bg-light border-bottom">
//                                     <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-start gap-2">
//                                         <div>
//                                             <h5 className="fw-bold text-dark mb-1">{viewProductItem.productName}</h5>
//                                             <div className="d-flex align-items-center gap-2">
//                                                 <span className="badge bg-white border text-secondary extra-small">{getCategoryName(viewProductItem.categoryId)}</span>
//                                                 <span className="text-secondary extra-small fw-bold">{getBrandName(viewProductItem.brandId)}</span>
//                                             </div>
//                                         </div>
//                                         <div className="text-md-end">
//                                             <h4 className="fw-bold mb-0" style={{color: THEME_COLOR}}>{formatCurrency(viewProductItem.sellingPrice)}</h4>
//                                             <Badge bg={viewProductItem.quantityAvailable > 0 ? 'success' : 'danger'} className="extra-small">{viewProductItem.quantityAvailable > 0 ? 'In Stock' : 'Out of Stock'}</Badge>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row g-0">
//                                     <div className="col-12 col-md-7 p-3 p-md-4 border-end">
//                                         <div className="mb-4">
//                                             <div style={styles.label}>Description</div>
//                                             <p className="text-secondary small">{viewProductItem.description || "No description provided."}</p>
//                                         </div>
//                                     </div>
//                                     <div className="col-12 col-md-5 p-3 p-md-4 bg-light">
//                                         <div style={styles.label} className="mb-3">Image Gallery</div>
//                                         <div className="row g-2">
//                                             {allImages.filter(img => img.productId === (viewProductItem.prodcutId || viewProductItem.productId)).map((img, idx) => (
//                                                 <div className="col-6" key={idx}>
//                                                     <img src={img.imageSrc} alt="" className="w-100 rounded shadow-sm" style={{height: '100px', objectFit: 'cover'}} />
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </Modal.Body>
//                 </Modal>

//                 <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered backdrop="static">
//                     <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold h6">{productValues.prodcutId === emptyGuid ? "New Product" : "Edit Product"}</Modal.Title></Modal.Header>
//                     <Modal.Body className="p-3 p-md-4">
//                         <form onSubmit={handleProductSubmit}>
//                             <Row className="g-2 g-md-3">
//                                 <Col xs={12} md={6}><div className="form-floating"><input type="text" className={`form-control ${productErrors.productName ? 'is-invalid' : ''}`} id="pName" placeholder="Name" name="productName" value={productValues.productName} onChange={handleProductInput} /><label htmlFor="pName">Product Name</label></div></Col>
//                                 <Col xs={12} md={6}><div className="form-floating"><input type="text" className="form-control" id="pSlug" placeholder="Slug" name="slug" value={productValues.slug} onChange={handleProductInput} /><label htmlFor="pSlug">Slug (Optional)</label></div></Col>
//                                 <Col xs={12} md={6}><div className="form-floating"><select className={`form-select ${productErrors.categoryId ? 'is-invalid' : ''}`} id="pCat" name="categoryId" value={productValues.categoryId} onChange={handleProductInput}><option value="">Select Category</option>{categories.map(c => <option key={c.categoryId} value={c.categoryId}>{c.name}</option>)}</select><label htmlFor="pCat">Category</label></div></Col>
//                                 <Col xs={12} md={6}><div className="form-floating"><select className={`form-select ${productErrors.brandId ? 'is-invalid' : ''}`} id="pBrand" name="brandId" value={productValues.brandId} onChange={handleProductInput}><option value="">Select Brand</option>{brandsDropdown.map(b => <option key={b.brandId} value={b.brandId}>{b.brandName}</option>)}</select><label htmlFor="pBrand">Brand</label></div></Col>
//                                 <Col xs={12}><div className="form-floating"><textarea className="form-control" placeholder="Desc" id="pDesc" style={{height: '100px'}} name="description" value={productValues.description} onChange={handleProductInput}></textarea><label htmlFor="pDesc">Description</label></div></Col>
//                                 <Col xs={4} md={4}><div className="form-floating"><input type="number" className="form-control" id="pQty" placeholder="0" name="quantityAvailable" value={productValues.quantityAvailable} onChange={handleProductInput} /><label htmlFor="pQty">Qty</label></div></Col>
//                                 <Col xs={4} md={4}><div className="form-floating"><input type="number" className="form-control" id="pBuy" placeholder="0" name="purchasePrice" value={productValues.purchasePrice} onChange={handleProductInput} /><label htmlFor="pBuy">Cost</label></div></Col>
//                                 <Col xs={4} md={4}><div className="form-floating"><input type="number" className="form-control" id="pSell" placeholder="0" name="sellingPrice" value={productValues.sellingPrice} onChange={handleProductInput} /><label htmlFor="pSell">Sell</label></div></Col>
//                                 <Col xs={12}><div className="form-check form-switch p-3 bg-light rounded-3 d-flex align-items-center gap-3"><input className="form-check-input m-0" type="checkbox" role="switch" id="pActive" name="isActive" checked={productValues.isActive} onChange={handleProductInput} style={{width: '2.5em', height: '1.2em'}} /><label className="form-check-label fw-bold text-dark small" htmlFor="pActive">Active Status</label></div></Col>
//                             </Row>
//                             <div className="d-flex justify-content-end gap-2 mt-4">
//                                 <Button variant="light" className="px-3 flex-grow-1 flex-md-grow-0" onClick={() => setShowProductModal(false)}>Cancel</Button>
//                                 <Button type="submit" className="px-4 text-white fw-bold shadow-sm flex-grow-1 flex-md-grow-0" disabled={productLoading} style={{backgroundColor: THEME_COLOR, border: 'none'}}>{productLoading ? 'Saving...' : 'Save'}</Button>
//                             </div>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 {/* IMAGE MODAL */}
//                 <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
//                     <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold h6">Gallery Manager</Modal.Title></Modal.Header>
//                     <Modal.Body className="p-3 p-md-4">
//                         <div className="p-3 bg-light rounded-4 mb-4 border border-dashed text-center">
//                             <form onSubmit={handleImageUpload} className="d-flex flex-column align-items-center gap-2">
//                                 {imageFormValues.imageSrc ? (
//                                     <img src={imageFormValues.imageSrc} alt="" className="shadow-sm rounded-3 mb-2" style={{width: '80px', height: '80px', objectFit: 'cover'}} />
//                                 ) : (
//                                     <div className="bg-white rounded-3 shadow-sm d-flex align-items-center justify-content-center mb-2" style={{width: '60px', height: '60px'}}><i className="ri-image-add-line fs-3 text-muted"></i></div>
//                                 )}
//                                 <div className="d-flex flex-column flex-md-row gap-2 w-100 justify-content-center">
//                                     <input type="file" accept="image/*" onChange={handleImageFileChange} className="form-control form-control-sm" />
//                                     <Button type="submit" size="sm" disabled={imageLoading} className="text-white px-3 fw-bold" style={{backgroundColor: THEME_COLOR}}>{imageLoading ? '...' : 'Upload'}</Button>
//                                 </div>
//                             </form>
//                         </div>
//                         <div className="row g-2 overflow-auto" style={{ maxHeight: '300px' }}>
//                             {allImages.filter(img => img.productId === (currentProductForImage?.prodcutId || currentProductForImage?.productId)).map((img, idx) => (
//                                 <div className="col-4 col-md-3" key={idx}>
//                                     <div className="card border-0 shadow-sm overflow-hidden position-relative">
//                                         <img src={img.imageSrc} alt="" className="w-100" style={{height: '80px', objectFit: 'cover'}} />
//                                         <button className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 p-0 px-1 shadow" onClick={() => { setImageToDelete(img.productImageId); setShowImageDeleteModal(true); }}><i className="ri-close-line"></i></button>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </Modal.Body>
//                 </Modal>

//                 {/* OTHER MODALS: LOGIC UNTOUCHED */}
//                 <Modal show={showProductDeleteModal} onHide={() => setShowProductDeleteModal(false)} centered size="sm">
//                     <Modal.Body className="text-center py-4">
//                         <h6 className="fw-bold text-danger">Delete Product?</h6>
//                         <p className="text-muted extra-small">Action cannot be undone.</p>
//                         <div className="d-flex flex-column gap-2 mt-3">
//                             <Button variant="danger" size="sm" onClick={handleProductDelete}>Confirm Delete</Button>
//                             <Button variant="light" size="sm" onClick={() => setShowProductDeleteModal(false)}>Cancel</Button>
//                         </div>
//                     </Modal.Body>
//                 </Modal>
//             </div>
//             <style>{`.extra-small { font-size: 0.7rem !important; } .font-normal { font-weight: normal !important; }`}</style>
//         </div>
//     );
// };

// export default Product;





import React, { useEffect, useState } from 'react';
import { Modal, Button, Badge, Row, Col } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const emptyGuid = '00000000-0000-0000-0000-000000000000';
const THEME_COLOR = '#065f46';
const SECONDARY_COLOR = '#64748b';

const styles = {
    pageBackground: { backgroundColor: '#f1f5f9', minHeight: '100vh', paddingTop: '80px' },
    card: { border: 'none', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' },
    tableHeader: { backgroundColor: '#f8fafc', color: '#475569', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' },
    imgThumbnail: { width: '56px', height: '56px', objectFit: 'cover', borderRadius: '12px', border: '2px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
    actionBtn: { width: '36px', height: '36px', padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', transition: 'all 0.2s' },
    modalHeader: { borderBottom: '1px solid #f1f5f9', padding: '20px 24px' },
    label: { fontSize: '0.8rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '4px' }
};

const initialProductValues = { prodcutId: emptyGuid, categoryId: '', brandId: '', productName: '', slug: '', description: '', quantityAvailable: 0, purchasePrice: 0, sellingPrice: 0, isActive: true };
const initialBrandValues = { brandId: emptyGuid, brandName: '' };
const initialImageValues = { productImageId: emptyGuid, productId: '', imageFile: null, imageSrc: '' };

const Product = () => {
    const [productList, setProductList] = useState([]);
    const [categories, setCategories] = useState([]); 
    const [brandsDropdown, setBrandsDropdown] = useState([]);
    
    const [showProductModal, setShowProductModal] = useState(false);
    const [productValues, setProductValues] = useState(initialProductValues);
    const [productErrors, setProductErrors] = useState({});
    
    const [showProductDeleteModal, setShowProductDeleteModal] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const [productLoading, setProductLoading] = useState(false);

    const [brandList, setBrandList] = useState([]);
    const [showBrandListModal, setShowBrandListModal] = useState(false);
    const [showBrandFormModal, setShowBrandFormModal] = useState(false);
    const [brandValues, setBrandValues] = useState(initialBrandValues);
    const [brandErrors, setBrandErrors] = useState({});
    const [showBrandDeleteModal, setShowBrandDeleteModal] = useState(false);
    const [brandToDelete, setBrandToDelete] = useState(null);
    const [brandLoading, setBrandLoading] = useState(false);

    const [allImages, setAllImages] = useState([]); 
    const [showImageModal, setShowImageModal] = useState(false); 
    const [currentProductForImage, setCurrentProductForImage] = useState(null); 
    const [imageFormValues, setImageFormValues] = useState(initialImageValues); 
    const [imageErrors, setImageErrors] = useState({});
    const [imageLoading, setImageLoading] = useState(false);
    const [showImageDeleteModal, setShowImageDeleteModal] = useState(false);
    const [imageToDelete, setImageToDelete] = useState(null);

    const [showViewModal, setShowViewModal] = useState(false);
    const [viewProductItem, setViewProductItem] = useState(null);
    
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    const LoadData = async () => {
        try {
            const [prodRes, catRes, brandRes, imgRes] = await Promise.all([
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
                axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES),
                axios.get(config.APIACTIVEURL + config.GETALLBRANDS),
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
            ]);
            setProductList(prodRes.data || []);
            setCategories(catRes.data || []);
            setBrandsDropdown(brandRes.data || []);
            setAllImages(imgRes.data || []);
        } catch (error) { console.error("Error loading data", error); }
    };

    const RefreshProducts = async () => { setProductList((await axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS)).data || []); };
    const RefreshBrands = async () => { 
        const res = await axios.get(config.APIACTIVEURL + config.GETALLBRANDS);
        setBrandList(res.data || []); setBrandsDropdown(res.data || []); 
    };
    const RefreshImages = async () => { setAllImages((await axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)).data || []); };

    useEffect(() => { LoadData(); }, []);

    const getMainImage = (prodId) => { 
        const img = allImages.find(x => x.productId === prodId); 
        return img ? img.imageSrc : null; 
    };
    const getCategoryName = (id) => { const cat = categories.find(c => c.categoryId === id); return cat ? cat.name : 'Uncategorized'; };
    const getBrandName = (id) => { const br = brandsDropdown.find(b => b.brandId === id); return br ? br.brandName : 'No Brand'; };
    
    const formatCurrency = (amount) => {
        return `${currency} ${amount?.toFixed(2) || '0.00'}`;
    };

    const handleProductInput = (e) => { const { name, value, type, checked } = e.target; setProductValues({ ...productValues, [name]: type === 'checkbox' ? checked : value }); };
    const handleProductSubmit = async (e) => {
        e.preventDefault();
        let temp = {};
        if(!productValues.productName) temp.productName = "Required";
        if(!productValues.categoryId) temp.categoryId = "Required";
        if(!productValues.brandId) temp.brandId = "Required";
        setProductErrors(temp);
        if(Object.values(temp).some(x => x)) return;

        setProductLoading(true);
        try {
            const isNew = productValues.prodcutId === emptyGuid;
            await axios({
                method: isNew ? 'POST' : 'PUT',
                url: config.APIACTIVEURL + (isNew ? config.CREATEPRODUCT : config.UPDATEPRODUCT),
                data: productValues
            });
            setShowProductModal(false); setProductValues(initialProductValues); RefreshProducts();
        } catch (error) { console.error(error); } finally { setProductLoading(false); }
    };
    const handleProductDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEPRODUCT}/${productToDelete}`); setShowProductDeleteModal(false); RefreshProducts(); };

    const handleBrandSubmit = async (e) => {
        e.preventDefault();
        if (!brandValues.brandName) { setBrandErrors({ brandName: "Required" }); return; }
        setBrandLoading(true);
        try {
            const isNew = brandValues.brandId === emptyGuid;
            await axios({ method: isNew ? 'POST' : 'PUT', url: config.APIACTIVEURL + (isNew ? config.CREATEBRAND : config.UPDATEBRAND), data: brandValues });
            setShowBrandFormModal(false); RefreshBrands();
        } catch(e){console.error(e)} finally{setBrandLoading(false)}
    };
    const handleBrandDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEBRAND}/${brandToDelete}`); setShowBrandDeleteModal(false); RefreshBrands(); };
    const handleViewBrands = () => { setShowBrandListModal(true); RefreshBrands(); };
    const openBrandForm = (item = null) => { setBrandValues(item || initialBrandValues); setBrandErrors({}); setShowBrandFormModal(true); };

    const handleManageImages = (product) => { 
        const actualId = product.prodcutId || product.productId;
        setCurrentProductForImage(product); 
        setImageFormValues({ ...initialImageValues, productId: actualId }); 
        setImageErrors({});
        setShowImageModal(true); 
    };

    const handleImageFileChange = (e) => {
        if (e.target.files[0]) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onload = (x) => setImageFormValues({ ...imageFormValues, imageFile: file, imageSrc: x.target.result });
            reader.readAsDataURL(file);
        }
    };

    const handleImageUpload = async (e) => {
        e.preventDefault();
        if (!imageFormValues.imageFile) { setImageErrors({ imageFile: "Select an image" }); return; }
        setImageLoading(true);

        const actualId = currentProductForImage.prodcutId || currentProductForImage.productId;
        const formData = new FormData();
        formData.append('ProductImageId', emptyGuid); 
        formData.append('ProductId', actualId); 
        formData.append('ImageFile', imageFormValues.imageFile);

        try { 
            await axios.post(config.APIACTIVEURL + config.CREATEPRODUCTIMAGE, formData); 
            setImageFormValues({ ...initialImageValues, productId: actualId }); 
            RefreshImages(); 
        }
        catch(e){ console.error("Upload failed", e.response?.data || e.message); } 
        finally{ setImageLoading(false); }
    };

    const handleImageDelete = async () => { await axios.delete(`${config.APIACTIVEURL}${config.DELETEPRODUCTIMAGE}/${imageToDelete}`); setShowImageDeleteModal(false); RefreshImages(); };

    const handleViewDetails = (item) => { setViewProductItem(item); setShowViewModal(true); };

    return (
        <div style={styles.pageBackground}>
            <div className="container-fluid px-4 pb-5">
                
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                    <div>
                        <h3 className="fw-bold mb-1" style={{ color: '#1e293b' }}>Products</h3>
                        <p className="text-muted mb-0">Manage catalog, brands, and galleries.</p>
                    </div>
                    <button className="btn text-white fw-bold px-4 shadow-sm"
                        style={{ backgroundColor: THEME_COLOR }}
                        onClick={() => { setProductValues(initialProductValues); setShowProductModal(true); }}>
                        <i className="ri-add-line me-1"></i> Add Product
                    </button>
                </div>

                <div className="card" style={styles.card}>
                    <div className="card-body p-0">
                        {/* --- WEB VIEW: TABLE --- */}
                        <div className="table-responsive rounded-4 d-none d-md-block">
                            <table className="table table-hover align-middle mb-0">
                                <thead style={styles.tableHeader}>
                                    <tr>
                                        <th className="ps-4 py-3">Product</th>
                                        <th className="py-3">Category</th>
                                        <th className="py-3">Brand</th>
                                        <th className="py-3">Stock</th>
                                        <th className="py-3">Price</th>
                                        <th className="py-3">Status</th>
                                        <th className="py-3 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productList.map((item) => {
                                        const actualId = item.prodcutId || item.productId;
                                        const thumbSrc = getMainImage(actualId);
                                        return (
                                            <tr key={actualId}>
                                                <td className="ps-4 py-3">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="position-relative">
                                                            {thumbSrc ? (
                                                                <img src={thumbSrc} alt="" style={styles.imgThumbnail} />
                                                            ) : (
                                                                <div className="d-flex align-items-center justify-content-center bg-light rounded-3" style={{ width: '56px', height: '56px' }}>
                                                                    <i className="ri-image-line text-muted fs-4"></i>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold text-dark">{item.productName}</div>
                                                            <small className="text-muted d-block">{item.slug}</small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td><span className="badge bg-light text-secondary border fw-normal px-2 py-1">{getCategoryName(item.categoryId)}</span></td>
                                                <td><span className="fw-bold" style={{ color: SECONDARY_COLOR }}>{getBrandName(item.brandId)}</span></td>
                                                <td><span className={`fw-bold ${item.quantityAvailable < 10 ? 'text-danger' : 'text-dark'}`}>{item.quantityAvailable} units</span></td>
                                                <td className="fw-bold text-dark">{formatCurrency(item.sellingPrice)}</td>
                                                <td><span className={`badge rounded-pill px-3 py-2 ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>{item.isActive ? 'Active' : 'Inactive'}</span></td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-1">
                                                        <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => handleViewDetails(item)} title="View Details"><i className="ri-eye-line"></i></button>
                                                        <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => handleManageImages(item)} title="Gallery"><i className="ri-image-add-line text-warning"></i></button>
                                                        <button className="btn btn-light border-0" style={styles.actionBtn} onClick={handleViewBrands} title="Brands"><i className="ri-price-tag-3-line text-info"></i></button>
                                                        <button className="btn btn-light border-0" style={styles.actionBtn} onClick={() => { setProductValues(item); setShowProductModal(true); }}><i className="ri-pencil-line text-primary"></i></button>
                                                        <button className="btn btn-light border-0" style={{...styles.actionBtn, backgroundColor: '#fef2f2'}} onClick={() => { setProductToDelete(actualId); setShowProductDeleteModal(true); }}><i className="ri-delete-bin-line text-danger"></i></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* --- MOBILE VIEW: CARDS --- */}
                        <div className="d-md-none p-3">
                            {productList.map((item) => {
                                const actualId = item.prodcutId || item.productId;
                                const thumbSrc = getMainImage(actualId);
                                return (
                                    <div key={actualId} className="card mb-3 border shadow-sm rounded-4 overflow-hidden">
                                        <div className="card-body p-3">
                                            <div className="d-flex align-items-center gap-3 mb-3">
                                                {thumbSrc ? (
                                                    <img src={thumbSrc} alt="" style={{...styles.imgThumbnail, width: '64px', height: '64px'}} />
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-center bg-light rounded-3" style={{ width: '64px', height: '64px' }}>
                                                        <i className="ri-image-line text-muted fs-3"></i>
                                                    </div>
                                                )}
                                                <div className="flex-grow-1">
                                                    <div className="d-flex justify-content-between">
                                                        <h6 className="fw-bold mb-0 text-dark">{item.productName}</h6>
                                                        <Badge bg={item.isActive ? 'success' : 'danger'} pill>{item.isActive ? 'Active' : 'Off'}</Badge>
                                                    </div>
                                                    <small className="text-muted">{item.slug || 'No slug'}</small>
                                                </div>
                                            </div>
                                            <div className="bg-light p-2 rounded-3 mb-3 row g-0 text-center">
                                                <div className="col-4 border-end">
                                                    <small className="d-block text-muted" style={{fontSize: '10px'}}>STOCK</small>
                                                    <span className={`fw-bold small ${item.quantityAvailable < 10 ? 'text-danger' : 'text-dark'}`}>{item.quantityAvailable}</span>
                                                </div>
                                                <div className="col-4 border-end">
                                                    <small className="d-block text-muted" style={{fontSize: '10px'}}>PRICE</small>
                                                    <span className="fw-bold small">{formatCurrency(item.sellingPrice)}</span>
                                                </div>
                                                <div className="col-4">
                                                    <small className="d-block text-muted" style={{fontSize: '10px'}}>BRAND</small>
                                                    <span className="fw-bold small text-truncate d-block px-1">{getBrandName(item.brandId)}</span>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between gap-1 flex-wrap">
                                                <Button variant="light" size="sm" className="flex-grow-1 border" onClick={() => handleViewDetails(item)}><i className="ri-eye-line text-dark"></i></Button>
                                                <Button variant="light" size="sm" className="flex-grow-1 border" onClick={() => handleManageImages(item)}><i className="ri-image-add-line text-warning"></i></Button>
                                                <Button variant="light" size="sm" className="flex-grow-1 border" onClick={handleViewBrands}><i className="ri-price-tag-3-line text-info"></i></Button>
                                                <Button variant="light" size="sm" className="flex-grow-1 border" onClick={() => { setProductValues(item); setShowProductModal(true); }}><i className="ri-pencil-line text-primary"></i></Button>
                                                <Button variant="danger" size="sm" className="flex-grow-1" onClick={() => { setProductToDelete(actualId); setShowProductDeleteModal(true); }}><i className="ri-delete-bin-line"></i></Button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg" centered>
                    <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold"><i className="ri-price-tag-3-fill me-2" style={{color: THEME_COLOR}}></i>Product Overview</Modal.Title></Modal.Header>
                    <Modal.Body className="p-0">
                        {viewProductItem && (
                            <div className="container-fluid p-0">
                                <div className="p-4 bg-light border-bottom">
                                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                                        <div>
                                            <h4 className="fw-bold text-dark mb-1">{viewProductItem.productName}</h4>
                                            <div className="d-flex align-items-center gap-2">
                                                <span className="badge bg-white border text-secondary">{getCategoryName(viewProductItem.categoryId)}</span>
                                                <span className="text-secondary small fw-bold">{getBrandName(viewProductItem.brandId)}</span>
                                            </div>
                                        </div>
                                        <div className="text-md-end">
                                            <h3 className="fw-bold mb-0" style={{color: THEME_COLOR}}>{formatCurrency(viewProductItem.sellingPrice)}</h3>
                                            <Badge bg={viewProductItem.quantityAvailable > 0 ? 'success' : 'danger'}>{viewProductItem.quantityAvailable > 0 ? 'In Stock' : 'Out of Stock'}</Badge>
                                        </div>
                                    </div>
                                </div>
                                <div className="row g-0">
                                    <div className="col-md-7 p-4 border-end">
                                        <div className="mb-4">
                                            <div style={styles.label}>Description</div>
                                            <p className="text-secondary small">{viewProductItem.description || "No description provided."}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-5 p-4 bg-light">
                                        <div style={styles.label} className="mb-3">Image Gallery</div>
                                        <div className="row g-2">
                                            {allImages.filter(img => img.productId === (viewProductItem.prodcutId || viewProductItem.productId)).map((img, idx) => (
                                                <div className="col-6" key={idx}>
                                                    <img src={img.imageSrc} alt="" className="w-100 rounded shadow-sm" style={{height: '100px', objectFit: 'cover'}} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                </Modal>

                <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered backdrop="static">
                    <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold">{productValues.prodcutId === emptyGuid ? "New Product" : "Edit Product"}</Modal.Title></Modal.Header>
                    <Modal.Body className="p-4">
                        <form onSubmit={handleProductSubmit}>
                            <Row className="g-3">
                                <Col md={6}><div className="form-floating"><input type="text" className={`form-control ${productErrors.productName ? 'is-invalid' : ''}`} id="pName" placeholder="Name" name="productName" value={productValues.productName} onChange={handleProductInput} /><label htmlFor="pName">Product Name</label></div></Col>
                                <Col md={6}><div className="form-floating"><input type="text" className="form-control" id="pSlug" placeholder="Slug" name="slug" value={productValues.slug} onChange={handleProductInput} /><label htmlFor="pSlug">Slug (Optional)</label></div></Col>
                                <Col md={6}><div className="form-floating"><select className={`form-select ${productErrors.categoryId ? 'is-invalid' : ''}`} id="pCat" name="categoryId" value={productValues.categoryId} onChange={handleProductInput}><option value="">Select Category</option>{categories.map(c => <option key={c.categoryId} value={c.categoryId}>{c.name}</option>)}</select><label htmlFor="pCat">Category</label></div></Col>
                                <Col md={6}><div className="form-floating"><select className={`form-select ${productErrors.brandId ? 'is-invalid' : ''}`} id="pBrand" name="brandId" value={productValues.brandId} onChange={handleProductInput}><option value="">Select Brand</option>{brandsDropdown.map(b => <option key={b.brandId} value={b.brandId}>{b.brandName}</option>)}</select><label htmlFor="pBrand">Brand</label></div></Col>
                                <Col md={12}><div className="form-floating"><textarea className="form-control" placeholder="Desc" id="pDesc" style={{height: '100px'}} name="description" value={productValues.description} onChange={handleProductInput}></textarea><label htmlFor="pDesc">Description</label></div></Col>
                                <Col md={4}><div className="form-floating"><input type="number" className="form-control" id="pQty" placeholder="0" name="quantityAvailable" value={productValues.quantityAvailable} onChange={handleProductInput} /><label htmlFor="pQty">Quantity</label></div></Col>
                                <Col md={4}><div className="form-floating"><input type="number" className="form-control" id="pBuy" placeholder="0" name="purchasePrice" value={productValues.purchasePrice} onChange={handleProductInput} /><label htmlFor="pBuy">Price ({currency})</label></div></Col>
                                <Col md={4}><div className="form-floating"><input type="number" className="form-control" id="pSell" placeholder="0" name="sellingPrice" value={productValues.sellingPrice} onChange={handleProductInput} /><label htmlFor="pSell">Selling Price ({currency})</label></div></Col>
                                <Col md={12}><div className="form-check form-switch p-3 bg-light rounded-3 d-flex align-items-center gap-3"><input className="form-check-input m-0" type="checkbox" role="switch" id="pActive" name="isActive" checked={productValues.isActive} onChange={handleProductInput} style={{width: '3em', height: '1.5em'}} /><label className="form-check-label fw-bold text-dark" htmlFor="pActive">Product is Active</label></div></Col>
                            </Row>
                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <Button variant="light" className="px-4 rounded-pill" onClick={() => setShowProductModal(false)}>Cancel</Button>
                                <Button type="submit" className="px-5 rounded-pill text-white fw-bold shadow-sm" disabled={productLoading} style={{backgroundColor: THEME_COLOR, border: 'none'}}>{productLoading ? 'Saving...' : 'Save Product'}</Button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>

                <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
                    <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold h5">Gallery Manager</Modal.Title></Modal.Header>
                    <Modal.Body className="p-4">
                        <div className="p-4 bg-light rounded-4 mb-4 border border-dashed text-center">
                            <h6 className="fw-bold text-dark mb-3">Upload New Image</h6>
                            <form onSubmit={handleImageUpload} className="d-flex flex-column align-items-center gap-3">
                                {imageFormValues.imageSrc ? (
                                    <img src={imageFormValues.imageSrc} alt="" className="shadow-sm rounded-3" style={{width: '100px', height: '100px', objectFit: 'cover'}} />
                                ) : (
                                    <div className="bg-white rounded-3 shadow-sm d-flex align-items-center justify-content-center" style={{width: '100px', height: '100px'}}><i className="ri-image-add-line fs-2 text-muted"></i></div>
                                )}
                                <div className="d-flex gap-2 w-100 justify-content-center flex-wrap">
                                    <input type="file" accept="image/*" onChange={handleImageFileChange} className="form-control w-md-50" />
                                    <Button type="submit" disabled={imageLoading} className="text-white px-4 fw-bold" style={{backgroundColor: THEME_COLOR}}>Upload</Button>
                                </div>
                                {imageErrors.imageFile && <small className="text-danger">{imageErrors.imageFile}</small>}
                            </form>
                        </div>
                        <div className="row g-3">
                            {allImages.filter(img => img.productId === (currentProductForImage?.prodcutId || currentProductForImage?.productId)).map((img, idx) => (
                                <div className="col-6 col-md-3" key={idx}>
                                    <div className="card border-0 shadow-sm overflow-hidden position-relative group-action">
                                        <img src={img.imageSrc} alt="" className="w-100" style={{height: '120px', objectFit: 'cover'}} />
                                        <button className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2 shadow" onClick={() => { setImageToDelete(img.productImageId); setShowImageDeleteModal(true); }}><i className="ri-delete-bin-line"></i></button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showBrandListModal} onHide={() => setShowBrandListModal(false)} centered scrollable>
                    <Modal.Header closeButton style={styles.modalHeader}><Modal.Title className="fw-bold h5">Brand Management</Modal.Title></Modal.Header>
                    <Modal.Body className="p-0">
                        <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
                            <span className="text-muted small fw-bold text-uppercase">Brands List</span>
                            <Button size="sm" className="text-white rounded-pill fw-bold" style={{backgroundColor: THEME_COLOR}} onClick={() => openBrandForm()}>+ Add Brand</Button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <tbody>
                                    {brandList.map(item => (
                                        <tr key={item.brandId}>
                                            <td className="ps-4 fw-bold text-dark">{item.brandName}</td>
                                            <td className="text-end pe-4">
                                                <button className="btn btn-link p-0 text-primary me-3 text-decoration-none" onClick={() => openBrandForm(item)}>Edit</button>
                                                <button className="btn btn-link p-0 text-danger text-decoration-none" onClick={() => { setBrandToDelete(item.brandId); setShowBrandDeleteModal(true); }}>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showBrandFormModal} onHide={() => setShowBrandFormModal(false)} centered>
                    <Modal.Body className="p-4">
                        <h5 className="fw-bold mb-3">{brandValues.brandId === emptyGuid ? 'Add Brand' : 'Edit Brand'}</h5>
                        <form onSubmit={handleBrandSubmit}>
                            <input className="form-control mb-3" placeholder="Brand Name" value={brandValues.brandName} onChange={(e) => setBrandValues({ ...brandValues, brandName: e.target.value })} />
                            <Button type="submit" className="w-100 text-white fw-bold" style={{backgroundColor: THEME_COLOR}}>Save</Button>
                        </form>
                    </Modal.Body>
                </Modal>

                <Modal show={showProductDeleteModal} onHide={() => setShowProductDeleteModal(false)} centered size="sm">
                    <Modal.Body className="text-center py-4">
                        <div className="display-4 text-danger mb-3"><i className="ri-alert-line"></i></div>
                        <h5 className="fw-bold">Delete Product?</h5>
                        <p className="text-muted small">This action cannot be undone.</p>
                        <div className="d-flex justify-content-center gap-2">
                            <Button variant="light" onClick={() => setShowProductDeleteModal(false)}>Cancel</Button>
                            <Button variant="danger" onClick={handleProductDelete}>Delete</Button>
                        </div>
                    </Modal.Body>
                </Modal>

                {[
                    { show: showBrandDeleteModal, hide: () => setShowBrandDeleteModal(false), action: handleBrandDelete, title: "Delete Brand?" },
                    { show: showImageDeleteModal, hide: () => setShowImageDeleteModal(false), action: handleImageDelete, title: "Delete Image?" }
                ].map((m, i) => (
                    <Modal key={i} show={m.show} onHide={m.hide} centered size="sm">
                        <Modal.Body className="text-center py-4">
                            <h5 className="fw-bold">{m.title}</h5>
                            <div className="d-flex justify-content-center gap-2 mt-3">
                                <Button variant="light" onClick={m.hide}>Cancel</Button>
                                <Button variant="danger" onClick={m.action}>Delete</Button>
                            </div>
                        </Modal.Body>
                    </Modal>
                ))}
            </div>
        </div>
    );
};

export default Product;